import { CSSProperties } from 'react'
import { CardTemplateProps, CustomTable,stringFilterTemplate } from 'medere-ui-framework'
import { Button } from 'primereact/button'
import { Column } from 'primereact/column'
import { useCalendarHolidayService } from '../../servicesHooks/CalendarHoliday/useCalendarHolidayService'
import { CalendarHolidayAuditItem } from '../../interface/CalendarHolidayTypes'

interface CalendarHolidayAuditProps {
  onClose: () => void
}

function formatDate(dateText: string): string {
  if (!dateText) return ''
  const date = new Date(`${dateText}T00:00:00`)
  if (Number.isNaN(date.getTime())) return dateText
  return date.toLocaleDateString('es-AR')
}

function formatDateTime(dateText: string): string {
  if (!dateText) return ''
  const date = new Date(dateText)
  if (Number.isNaN(date.getTime())) return dateText
  return date.toLocaleString('es-AR')
}

function CalendarHolidayAuditCard({ entity }: Readonly<CardTemplateProps>) {
  const audit = entity as CalendarHolidayAuditItem
  return (
    <article className='calendar-holiday-mobile-card'>
      <div className='calendar-holiday-mobile-card-header'>
        <h3 className='calendar-holiday-mobile-card-title'>{formatDateTime(audit.date)}</h3>
      </div>
      <div className='calendar-holiday-mobile-card-row'>
        <span className='calendar-holiday-mobile-card-key'>Feriado</span>
        <span className='calendar-holiday-mobile-card-value'>{formatDate(audit.holidaydate)}</span>
      </div>
      <div className='calendar-holiday-mobile-card-row'>
        <span className='calendar-holiday-mobile-card-key'>Evento</span>
        <span className='calendar-holiday-mobile-card-value'>{audit.eventdesc || '-'}</span>
      </div>
      <div className='calendar-holiday-mobile-card-row'>
        <span className='calendar-holiday-mobile-card-key'>Usuario</span>
        <span className='calendar-holiday-mobile-card-value'>{audit.useraudit || '-'}</span>
      </div>
    </article>
  )
}

export default function CalendarHolidayAudit({ onClose }: Readonly<CalendarHolidayAuditProps>) {
  const { getCalendarHolidayAudit } = useCalendarHolidayService()
  const TABLE_ROW_HEIGHT_PX = 36
  const tableStyle: CSSProperties = {
    ['--calendar-holiday-row-height' as string]: `${TABLE_ROW_HEIGHT_PX}px`,
  }
  return (
    <div className='viewContainer calendar-holiday-view'>
      <div className='calendar-holiday-back-action'>
        <Button className='btnCancel' label='<< Volver' onClick={onClose} />
      </div>

      <h1 className='calendar-holiday-title'>Feriados</h1>
      <p className='calendar-holiday-subtitle'>Historial de cambios</p>
      <div className='calendar-holiday-divider' />

      <CustomTable
        idTable='CalendarHolidayAuditTable'
        className='calendar-holiday-table'
        style={tableStyle}
        getItems={getCalendarHolidayAudit}
        itemSize={TABLE_ROW_HEIGHT_PX}
        dynamicBehaviour
        
        filterRow
        CardTemplate={CalendarHolidayAuditCard}
        cardKeyName='auditevent'
      >
        <Column field='date' header='Fecha del cambio' filter filterElement={stringFilterTemplate} body={(item: CalendarHolidayAuditItem) => formatDateTime(item.date)} />
        <Column field='holidaydate' header='Feriado' filter filterElement={stringFilterTemplate} body={(item: CalendarHolidayAuditItem) => formatDate(item.holidaydate)} />
        <Column field='eventdesc' header='Cambio realizado' filter filterElement={stringFilterTemplate} />
        <Column field='useraudit' header='Usuario' filter filterElement={stringFilterTemplate} style={{width:'25%'}} body={(item: CalendarHolidayAuditItem) => item.useraudit || '-'} />
      </CustomTable>
    </div>
  )
}
